import { TopBar } from "@/components/layout";
import { MapsList } from "@/components/thematic-maps/MapsList";
import { NewMapDialog } from "@/components/thematic-maps/NewMapDialog";

const ThematicMapsPage = () => {
  return (
    <>
      <TopBar title="Mapy Tematyczne" />
      <div className="flex-1 overflow-auto p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg font-semibold">Semantic Content Networks</h2>
            <p className="text-sm text-muted-foreground">
              Twórz i zarządzaj mapami tematycznymi (Macro → Seeds → Nodes)
            </p>
          </div>
          <NewMapDialog />
        </div>
        <MapsList />
      </div>
    </>
  );
};

export default ThematicMapsPage;
